import { render } from "./AssessmentQuestion.vue?vue&type=template&id=398e7df4&scoped=true"
import script from "./AssessmentQuestion.vue?vue&type=script&lang=js"
export * from "./AssessmentQuestion.vue?vue&type=script&lang=js"

import "@/assets/css/quiz.sass?vue&type=style&index=0&id=398e7df4&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398e7df4"]])

export default __exports__